import { useState, useContext } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { AppContext, ERROR_SEVERITY } from 'commons-ui';
import { SelectedAthenaCrudType } from 'pages/dashboard/athenaDashboard/listAthenaRequest/types';
import useService from '../../../useService';

const useAthenaCrudDetails = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { createAthenaCrudRequest } = useService();
	const { path } = useRouteMatch();

	const handleFormSubmit = async (selectedCrud: SelectedAthenaCrudType) => {
		setShowLoader(true);
		const { gameName, queryText, defaultQueryParams, label } = selectedCrud;
		try {
			setShowLoader(false);
			const response = await createAthenaCrudRequest(gameName, queryText, defaultQueryParams, label, showAlert);
			if (response) {
				history.push({
					pathname: `${path}/listAthenaCrudRequests`
				});
			}
		} catch (error: any) {
			showAlert(error.error || 'Something went wrong', { type: ERROR_SEVERITY.ERROR });
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { showLoader, setShowLoader, handleFormCancel, handleFormSubmit };
};
export default useAthenaCrudDetails;
